<template>
  <div class="sr-multiple-text context">
    <div :class="{ autoHeight: !expand ? false : true }">
      <span ref="text">
        {{ value }}
      </span>

      <div class="more_less" @click="expand = !expand" v-show="textHeight > 61">
        <i class="el-icon-arrow-down el-icon--right" v-show="!expand"></i>
        <i class="el-icon-arrow-up el-icon--right" v-show="expand"></i>
      </div>
    </div>
  </div>
</template> 

<script>
/**
 * line-height 高度为 22px;
 * 三行文字高度 61px
 * 如果当前text高度超过61 出现显示更多按钮
 */
export default {
  name: "SrMultipleText",
  model: {
    prop: "value",
    event: "change",
  },
  props: ["value", "item"],
  data() {
    return {
      textHeight: null,
      expand: false,
      height: null,
    };
  },
  watch: {
    value: {
      handler() {
        
      },
      deep: true,
    },
  },
  methods: {
    getValueHeight() {
      this.textHeight = this.$refs.text.offsetHeight;
    },
  },
  mounted() {
    this.getValueHeight();
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrMultipleText/SrMultipleText.vue